import { gql } from "graphql-request";

export const READ_COMPANY_ADDRESS_BY_ID = gql`
  query ReadCompanyAddressByID($id: ID!) {
    readCompanyAddressByID(id: $id) {
      id
      companyID
      label
      addressLine1
      addressLine2
      town
      county
      postcode
      country
      latitude
      longitude
      isPrimary
      createdAt
      updatedAt
      archivedAt
    }
  }
`;

export const READ_COMPANY_ADDRESSES_BY_COMPANY_ID = gql`
  query ReadCompanyAddressesByCompanyID($companyID: ID!) {
    readCompanyAddressesByCompanyID(companyID: $companyID) {
      id
      companyID
      label
      addressLine1
      addressLine2
      town
      county
      postcode
      country
      latitude
      longitude
      isPrimary
      createdAt
      updatedAt
      archivedAt
    }
  }
`;